import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { taskTransferM } from 'src/app/Models/BasicForms/taskTransferM';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-task-transfer-history',
  templateUrl: './task-transfer-history.component.html',
  styleUrls: ['./task-transfer-history.component.css']
})

export class TaskTransferHistoryComponent implements OnInit {

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService) { }

  formTitle = "Task Transfer History";

  ngOnInit(): void {
    // this.getAllTaskTransferHistory();

    this.logtext = 'OPENED - Task Transfer form KEYWORD[O - Task Transfer] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["ID", "ID"], ["TASK_ID", "Task ID"], ["FROM_USER_ID", "From"], ["TO_USER_ID", "To"], ["TRANSFER_DATETIME", "Date Time"]];
  filterQuery: string = "";
  isloadSpinning = false;
  loadingRecords = false;
  taskTransferData = [
    { ID: 1, TASK_ID: 1, FROM_USER_ID: 1, TO_USER_ID: 2, TRANSFER_DATETIME: "" },
    { ID: 2, TASK_ID: 2, FROM_USER_ID: 3, TO_USER_ID: 4, TRANSFER_DATETIME: "" }
  ];

  getAllTaskTransferHistory(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
      this.logtext = 'Filter Applied - Task Transfer form"+ sort +" "+this.sortKey +" KEYWORD [F - Task Transfer] ';
      this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
        if (successCode['code'] == "200") {

        }
        else {

        }
      });
    } catch (error) {
      sort = "";
    }


    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)

    }

    this.logtext = 'Filter Applied - Task Transfer form "+ likeQuery +" KEYWORD [F - Task Transfer] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });

    this._apiService.getAllTaskTransferHistory(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery).subscribe(data => {

      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.taskTransferData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  drawerVisible = false;
  drawerTitle = "";
  taskTransferHistoryDrawerData: taskTransferM = new taskTransferM();
  add() {
    this.drawerTitle = "Task Transfer";
    this.taskTransferHistoryDrawerData = new taskTransferM();
    this.drawerVisible = true;

    this.logtext = 'ADD - Task Transfer form KEYWORD [A - Task Transfer] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  edit(data: taskTransferM) {
    this.drawerTitle = "Task Transfer";
    this.taskTransferHistoryDrawerData = Object.assign({}, data);
    this.drawerVisible = true;



    this.logtext = 'EDIT - Task Transfer form KEYWORD [E - Task Transfer] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  drawerClose() {
    // this.getAllTaskTransferHistory();
    this.drawerVisible = false;
  }

  get callBackDrawerClose() {
    return this.drawerClose.bind(this);
  }
  sortKey: string = "id";
  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'desc';



    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    // this.getAllTaskTransferHistory();
  }
}
